import { Info4 } from "@assets";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { BodySmall } from "@components/Typography";
import { AccountType } from "@ctypes";
import { useGoalsContext } from "@hooks";
import { Translations, i18n } from "@i18n";
import { Intercom } from "@services/Intercom";
import { useStyles } from "./styles";

const BALANCE_SYNC_BANNER_ACCOUNT_TYPES: AccountType[] = [
  AccountType.FiveTwoNinePlan,
  AccountType.Individual_529,
];

export const BalanceSyncBanner = () => {
  const styles = useStyles();
  const { goal } = useGoalsContext();

  const accountType = goal?.accounts?.[0]?.type;

  if (!accountType || !BALANCE_SYNC_BANNER_ACCOUNT_TYPES.includes(accountType)) {
    return null;
  }

  return (
    <>
      <div
        role="button"
        tabIndex={0}
        style={styles.bar}
        onClick={() => Intercom.showChat()}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            Intercom.showChat();
          }
        }}
      >
        <Info4 size={24} />
        <div style={styles.textColumn}>
          <BodySmall style={styles.line}>
            {i18n.t(Translations.GoalBreakdownRouteBalanceSyncBannerText529)}
          </BodySmall>
          <BodySmall style={styles.line}>
            {i18n.t(Translations.GoalBreakdownRouteBalanceSyncBannerLink)}
          </BodySmall>
        </div>
      </div>
      <Spacing size={SpacingSizes.S} />
    </>
  );
};
